import { render, staticRenderFns } from "./AuthorizationCard.vue?vue&type=template&id=24af1648&"
import script from "./AuthorizationCard.vue?vue&type=script&lang=js&"
export * from "./AuthorizationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports